function fromPairs(pairs) {
    if (pairs) {
        pairs = Array.from(pairs);
    }
    var index = -1,
        length = pairs == null ? 0 : pairs.length,
        result = {};
    while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
    }
    return result;
}

var fromPairs_1 = fromPairs;

if ("function" !== typeof Object.fromEntries) {
    Object.fromEntries = fromPairs_1;
}
